// @flow

import invariant from 'invariant';

export opaque type Identifier = string;

/**
 * Regular Expression that matches any invalid characters in an ECMAScript
 * identifier.
 *
 * This is not actually correct, according to the spec all sorts of unicode
 * characters can be used in identifiers but I'm gonna go ahead and just rule
 * that out entirely.
 *
 * @see https://tc39.es/ecma262/#sec-identifier-names
 */
export const INVALID_IDENTIFIER_NAME_CHARACTERS: RegExp =
  /^[^a-z_$]|[^0-9a-z_$]/i;

export const isValidIdentifierName: (string) => boolean = (identifier) =>
  !INVALID_IDENTIFIER_NAME_CHARACTERS.test(identifier) ||
  identifier.trim().length === 0;

export const validateIdentifierName: (string) => void = (identifier) => {
  invariant(
    isValidIdentifierName(identifier),
    `Must be a valid identifier: ${identifier}

Attempted to use ${identifier} as an ECMAScript identifier, but it does not follow the rules for ECMAScript identifiers.

See: https://tc39.es/ecma262/#sec-identifier-names
`,
  );
};

export const asIdentifier: (string) => Identifier = (identifier) => {
  validateIdentifierName(identifier);
  return identifier;
};

export const identifierAsString: (Identifier) => string = (identifier) =>
  identifier;
